import { DateTimeField, TimeField } from "@mui/x-date-pickers";
import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { blueMui, redMui, rydeColors } from "@ryde/theme";

export const StationTimeEditFieldStyled = styled(
  TimeField,
).attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "station-time-edit-field",
})`
  .MuiPickersOutlinedInput-root {
    font-size: 14px;
    border-radius: 0 4px 4px 0;
    padding: 0;

    &.Mui-focused {
      .MuiPickersOutlinedInput-root {
        background: ${rydeColors.white};
      }
      .MuiPickersOutlinedInput-notchedOutline {
        border-width: 1px;
        border-color: ${blueMui._300};
      }
    }

    &:hover {
      .MuiPickersOutlinedInput-notchedOutline {
        border-color: ${blueMui._300};
      }
    }

    &.Mui-error {
      .MuiPickersOutlinedInput-root {
        background-color: ${rydeColors.redTimeEditBg};
      }
    }
  }

  .MuiPickersSectionList-root {
    background: ${rydeColors.blueTimeEditBg};
    padding: 0;
    height: 32px;
    width: 81px;
    justify-content: center;
    align-items: center;
  }

  .MuiPickersOutlinedInput-notchedOutline {
    border-color: ${blueMui._300};
  }

  &.has_overlap .MuiPickersSectionList-root {
    background-color: ${redMui._50};
  }
`;

export const StationDateTimeEditFieldStyled = styled(
  DateTimeField,
).attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "station-date-time-edit-field",
})`
  &.MuiPickersTextField-root {
    min-width: 90px;
  }

  .MuiPickersOutlinedInput-root {
    font-size: 14px;
    border-radius: 0 4px 4px 0;
    padding: 0;

    &.Mui-focused {
      .MuiPickersOutlinedInput-root {
        background: ${rydeColors.white};
      }
      .MuiPickersOutlinedInput-notchedOutline {
        border-width: 1px;
        border-color: ${blueMui._300};
      }
    }

    &:hover {
      .MuiPickersOutlinedInput-notchedOutline {
        border-color: ${blueMui._300};
      }
    }

    &.Mui-error {
      .MuiPickersOutlinedInput-root {
        background-color: ${rydeColors.redTimeEditBg};
      }
    }
  }

  .MuiPickersSectionList-root {
    background: ${rydeColors.blueTimeEditBg};
    padding: 0;
    height: 32px;
    width: 81px;
    justify-content: center;
    align-items: center;
  }

  .MuiPickersOutlinedInput-notchedOutline {
    border-color: ${blueMui._300};
  }

  &.has_overlap .MuiPickersSectionList-root {
    background-color: ${redMui._50};
  }
`;
